/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-199718, будет удалён в задаче CD-199865
 */

import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const NEWBUILDING_CPM_FORMAT_IN_CARD_EXPERIMENT = 'newbuilding_cpm_format_in_card';

export const selectIsNewbuildingCpmFormatInCardExperimentGroupA = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, NEWBUILDING_CPM_FORMAT_IN_CARD_EXPERIMENT, 'A');
};
